import styled from "@emotion/styled";
import theme from "@theme/";

const FolderStructureContainer = styled.div`
  padding: 10px;
  border: 1px solid ${theme.colors.bordertask};
  margin: 5px 15px 10px 30px;
  border-radius: 5px;
  max-height: 550px;
  overflow-y: auto;
  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  ::-webkit-scrollbar-track {
    background: ${theme.colors.bordertask};
  }

  ::-webkit-scrollbar-thumb {
    background: ${theme.colors.themeColor};
    border-radius: 10px;
  }
`;

const BodyContainer = styled.div`
  margin-top: 50px;
`;

const FilterContainer = styled.div`
  border-bottom: 1px solid ${theme.colors.bordertask};
  padding: 5px 30px 5px 5px;
  display: flex;
  gap: 10px;
  justify-content: end;
`;

const InfoRow = styled.div`
  display: flex;
  font-size: 12px;
  align-items: center;
`;

const Label = styled.p`
  font-weight: bold;
  margin: 0;
`;

const Value = styled.span`
  margin-left: 8px;
  font-weight: bold;
  opacity: 0.7;
`;

const DrawerTitlesContainer = styled.div`
  display: flex;
  background: ${theme.gradient.themeGradient};
  align-items: center;
  justify-content: space-between;
  padding: 0px 10px 0px 20px;
  height: 50px;
  position: sticky;
  top: 0;
  z-index: 2000;
`;

const CloseIcon = styled.p`
  cursor: pointer;
  color: white;
`;

const DrawerTitles = styled.span`
  font-size: 17px;
  color: white;
  font-weight: normal;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin: 30px 20px 0px 0px;
`;

const SC = {
  FolderStructureContainer,
  BodyContainer,
  FilterContainer,
  InfoRow,
  Label,
  Value,
  DrawerTitlesContainer,
  CloseIcon,
  DrawerTitles,
  ButtonContainer,
};

export default SC;
